import {
  IonActionSheet,
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonPage,
  useIonAlert,
  useIonToast,
} from '@ionic/react';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../lib/context/AppContext';
import {
  chevronForwardOutline,
  informationCircleOutline,
  trashOutline,
} from 'ionicons/icons';
import AccountInfoUpdateDetails from '../../../components/partials/accounts/AccountInfoUpdateDetails';
import Toolbar from '../../../components/Toolbar';
import { exitOutline } from 'ionicons/icons';
import { App } from '@capacitor/app';

const AccountTab: React.FC = (props) => {
  const { user, logout, apiService } = useContext(AppContext);
  const [present] = useIonToast();
  const [presentAlert] = useIonAlert();
  const [appInfo, setAppInfo] = useState('');

  useEffect(() => {
    const getAppInfo = async () => {
      const info = await App.getInfo();
      setAppInfo('v' + info.version);
    };
    getAppInfo();
  }, [App]);
  return (
    <>
      <IonPage className='h-full'>
        <IonHeader>
          <Toolbar title='Account'></Toolbar>
        </IonHeader>

        <IonContent>
          <div className='flex flex-col justify-between h-full'>
            <div className='flex-grow'>
              <AccountInfoUpdateDetails></AccountInfoUpdateDetails>

              <IonList>
                <IonListHeader>
                  <IonLabel>Impostazioni</IonLabel>
                </IonListHeader>
                <IonItem
                  href='mailto:cdrt@asconauto.it'
                  detail={true}
                  detailIcon={chevronForwardOutline}
                >
                  <IonLabel>Contattaci</IonLabel>
                </IonItem>
                <IonItem
                  detail={true}
                  detailIcon={exitOutline}
                  onClick={async () => {
                    await logout();
                    window.location.href = '/home';
                  }}
                >
                  <IonLabel>Esci</IonLabel>
                </IonItem>
              </IonList>
            </div>
            <div className='flex flex-col items-center justify-center py-4'>
              <IonButton id='delete-account-action-sheet' color={'danger'}>
                <IonIcon icon={trashOutline} className='mr-2'></IonIcon>
                <IonLabel>Elimina account</IonLabel>
              </IonButton>
              <span className='text-xs text-neutral-400 mt-4'>{appInfo}</span>
            </div>
          </div>

          <IonActionSheet
            trigger='delete-account-action-sheet'
            header='Elimina account'
            buttons={[
              {
                text: 'Prossimo step',
                role: 'destructive',
                handler: () => {
                  presentAlert({
                    header: 'Elimina account',
                    subHeader: 'Azione permanente',
                    message:
                      'Attenzione! Sei sicuro di voler eliminare il tuo account?',
                    buttons: [
                      {
                        text: 'Conferma ed Elimina',
                        handler: () => {
                          apiService?.delete(`/users/${user.id}`).then(
                            () => {
                              present({
                                icon: informationCircleOutline,
                                header: 'Account eliminato',
                                message: 'Account eliminato correttamente',
                                color: 'primary',
                                duration: 2500,
                                position: 'top',
                                layout: 'stacked',
                              });
                              logout();
                            },
                            (error) => {}
                          );
                        },
                      },
                      'Annulla',
                    ],
                  });
                },
              },
              {
                text: 'Annulla',
                role: 'cancel',
                data: {
                  action: 'cancel',
                },
              },
            ]}
          ></IonActionSheet>
        </IonContent>
      </IonPage>
    </>
  );
};

export default AccountTab;
